<template>
  <div class="tjInformation">
    <div class="posit">
      当前位置：
      优秀企业推介
      <span style="margin: 0 10px">></span>
      资讯中心
    </div>
    <div class="content">
      <ul>
        <li
          v-for="(item,index) in informtionList.slice( (pageIndex - 1 ) * pageSize, pageIndex * pageSize )"
          :key="index"
          @click="inforDetail(item.id)"
        >
          <div class="leftDiv">
            <img :src="item.image && $getSrc(item.image)" alt />
          </div>
          <div class="centerDiv">
            <p>{{ item.title }}</p>
            <p>{{ item.remarks }}</p>
          </div>
          <div class="rightDiv">
            <p>{{ item.uploadDate ? item.uploadDate : item.createDate }}</p>
            <p>
              围观
              <span>{{ item.watch }}</span>
              次
            </p>
          </div>
        </li>
      </ul>
    </div>
    <div class="fenye">
      <el-pagination
        background
        @current-change="currentChangeHandle"
        :current-page="pageIndex"
        :page-size="pageSize"
        :total="totalPage"
        layout="prev, pager, next, slot "
      >
        <el-input v-model="tiaoPage" class="tiaoInp"></el-input>
        <el-button class="tiaoBtn" @click="transfer">跳转</el-button>
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      informtionList: [],
      pageSize: 5, // 每页条数
      pageIndex: 1, // 当前页
      totalPage: 0, // 总条数
      totalIndex: 0, // 总页数
      tiaoPage: "",
      content: "",
      title: "",
      time: "",
      watch: "", // 浏览
      fabulous: 0, // 点赞
    };
  },
  activated() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      this.$http({
        url: "promotion/getTjContent",
        method: "get",
        params: {
          type: "6",
        },
      }).then(({ data }) => {
        let { code, promotion } = data;
        if (code === 0) {
          this.informtionList = promotion;
          this.totalPage = promotion.length;
          this.totalIndex = Math.ceil(promotion.length / this.pageSize);
        }
      });
    },
    // 详情
    inforDetail(id) {
      sessionStorage.setItem("coreId", true);
      this.$router.push({
        path: "/informationDetail",
        query: {
          detailId: id,
        },
      });
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
    },
    // 调转
    transfer() {
      if (this.tiaoPage * 1 > this.totalIndex) {
        this.$message.error("已超出总页数！");
      } else {
        this.pageIndex = this.tiaoPage * 1;
      }
    },
  },
};
</script>
<style lang="scss">
.tjInformation {
  .fenye {
    height: 32px;
    text-align: center;
    // margin: 60px 0;
    .el-icon-arrow-left:before {
      content: "上一页";
    }
    .el-icon-arrow-right:before {
      content: "下一页";
    }
    .el-pagination {
      padding: 0;
    }
    .btn-prev,
    .btn-next,
    .tiaoBtn {
      width: 54px;
      height: 32px;
      background-color: #eeeeee;
      line-height: 54px;
      color: #424242 !important;
    }
    .el-pager {
      li {
        width: 32px;
        height: 32px;
        background-color: #eeeeee;
        color: #525252;
        line-height: 32px;
      }
    }
    .el-pagination.is-background .el-pager li {
      &:hover {
        color: #7eb341;
        // background-color: #7eb341;
      }
    }
    .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #7eb341;
      &:hover {
        color: #ffffff;
      }
    }
    .tiaoInp {
      width: 32px;
      height: 32px;
      .el-input__inner {
        padding: 0;
        border-radius: 0;
        height: 32px;
      }
    }
    .tiaoBtn {
      border-radius: 2px;
      margin-left: 8px;
    }
    .el-pagination span:not([class*="suffix"]),
    .el-pagination button {
      line-height: 32px;
    }
  }
}
</style>
<style lang="scss" scoped>
.tjInformation {
  .posit {
    margin: 31px 0 15px 0;
    padding-left: 25px;
    color: #999999;
    font-size: 12px;
  }
  .content {
    width: 1157px;
    height: 745px;
    margin: 10px 0 51px 43px;
    ul {
      li {
        height: 148px;
        cursor: pointer;
        border-bottom: 1px solid #dfe1e1;
        .leftDiv {
          width: 140px;
          height: 88px;
          float: left;
          margin: 30px 22px 0 0;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            max-width: 100%;
            max-height: 100%;
            width: auto;
            height: auto;
            display: inline-block;
            vertical-align: middle;
          }
        }
        .centerDiv {
          width: 700px;
          height: 75px;
          float: left;
          margin-top: 36px;
          p:first-child {
            // width: 545px;
            font-weight: bold;
            font-size: 18px;
            color: #333333;
            margin-bottom: 9px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          p:last-child {
            font-size: 13px;
            color: #666666;
            line-height: 25px;
            text-indent: 37px;
            height: 50px;
            overflow: hidden;
            // width: 545px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
        }
        .rightDiv {
          height: 75px;
          float: right;
          font-size: 12px;
          color: #bbbbbb;
          margin-top: 40px;
          text-align: right;
          p:first-child {
            margin-bottom: 45px;
          }
        }
      }
    }
  }
}
</style>